import {
  IsNumber,
  IsOptional,
  IsString,
  IsUUID,
  Max,
  Min,
  MaxLength,
} from 'class-validator'
import { ApiPropertyOptional } from '@nestjs/swagger'
import { Transform } from 'class-transformer'
import {
  MAX_CLASS_NAME_LENGTH,
  MIN_MAX_STUDENTS,
  MAX_MAX_STUDENTS,
} from '../../../constants/class.constants'

const toNumber = ({ value }: { value: any }) => {
  if (value === '' || value === null || value === undefined) return undefined
  return Number(value)
}

export class UpdateClassDto {
  @ApiPropertyOptional({
    description: 'Nom de la classe',
    maxLength: MAX_CLASS_NAME_LENGTH,
    type: 'string',
  })
  @IsOptional()
  @IsString()
  @MaxLength(MAX_CLASS_NAME_LENGTH)
  name?: string

  @ApiPropertyOptional({ description: "ID de l'établissement", type: 'string' })
  @IsOptional()
  @IsUUID('4')
  establishmentId?: string

  @ApiPropertyOptional({ description: 'ID du niveau', type: 'string' })
  @IsOptional()
  @IsUUID('4')
  levelExternalId?: string

  @ApiPropertyOptional({ description: 'ID de la section', type: 'string' })
  @IsOptional()
  @IsUUID('4')
  sectionId?: string

  @ApiPropertyOptional({ description: "ID de l'année scolaire", type: 'string' })
  @IsOptional()
  @IsUUID('4')
  schoolYearId?: string

  @ApiPropertyOptional({ description: 'ID du statut', type: 'string' })
  @IsOptional()
  @IsUUID('4')
  statusId?: string

  @ApiPropertyOptional({
    description: "Nombre maximum d'élèves",
    minimum: MIN_MAX_STUDENTS,
    maximum: MAX_MAX_STUDENTS,
    type: Number,
  })
  @IsOptional()
  @Transform(toNumber)
  @IsNumber()
  @Min(MIN_MAX_STUDENTS)
  @Max(MAX_MAX_STUDENTS)
  maxStudents?: number
}
